import type { ReactNode } from 'react';

import { MarkdownStyles } from '@components/MarkdownStyles';

import styles from './PageWrapper.module.scss';

export const PageWrapper = ({ children }: { children: ReactNode }) => (
	<MarkdownStyles classNames={styles.page}>{children}</MarkdownStyles>
);
